import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { BATCH_BY_ORDER_COUNT, BATCH_BY_BATCH_COUNT } from '../constants/auto-batching-constants';
import messages from '../messages';
import style from '../style.module.less';

const AutoBatchHelperTip = ({ optionType, anticipatedCount }) => {
  const helperMessageDescriptor =
    optionType === BATCH_BY_ORDER_COUNT ? messages.suggestedBatchByOrderCountLabel : messages.suggestedBatchByBatchCountLabel;
  return (
    <span className={style['helper-tip']}>
      <FormattedMessage
        {...helperMessageDescriptor}
        values={{
          anticipatedCount,
          b: (chunks) => <span className={style['helper-bold']}>{chunks}</span>,
        }}
      />
    </span>
  );
};

AutoBatchHelperTip.propTypes = {
  optionType: PropTypes.oneOf([BATCH_BY_ORDER_COUNT, BATCH_BY_BATCH_COUNT]).isRequired,
  anticipatedCount: PropTypes.number.isRequired,
};

export { AutoBatchHelperTip };
